module.exports = __webpack_public_path__ + "img/Image-dip-homepage.5e75bb9c.png";